import React from 'react';
import { EntityForm } from '../../widgets/Forms';
import { CustomTextField } from '../../widgets/CustomTextField';
import { Row, Col } from 'react-bootstrap';
import { SelectItem } from '../../widgets/SelectItem';

export default function AccessorSearchForm(props) {
    return (
        <EntityForm ref={React.createRef()} viewId="assessor" values={props.data}
            entityLookupController={props.entityLookupController} org="saseta"
            entityLookupId={props.id} useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={form.classes.container} id="AssessorForm">
                    <div className="row search-form-container">
                        <div className="col form-col">
                            <CustomTextField
                                id="FirstName"
                                label="First Name"
                                className="w-100"
                                onKeyPress={props.onKeyUp}
                                InputProps={{
                                    readOnly: false,
                                }}
                                form={form}
                            />
                        </div>
                        <div className="col form-col">
                            <CustomTextField
                                id="MiddleName"
                                label="Middle Name"
                                className="w-100"
                                onKeyPress={props.onKeyUp}
                                InputProps={{
                                    readOnly: false,
                                }}
                                form={form}
                            />
                        </div>
                        <div className="col form-col">
                            <CustomTextField
                                id="Surname"
                                label="Surname"
                                className="w-100"
                                onKeyPress={props.onKeyUp}
                                InputProps={{
                                    readOnly: false,
                                }}
                                form={form}
                            />
                        </div>
                        <div className="col form-col">
                            <CustomTextField
                                id="IDNo"
                                label="ID Number"
                                className="w-100"
                                onKeyPress={props.onKeyUp}
                                InputProps={{
                                    readOnly: false,
                                }}
                                form={form}
                            />
                        </div>
                        <div className="col form-col">
                            <CustomTextField
                                id="RegistrationNumber"
                                label="Registration Number"
                                className="w-100"
                                onKeyPress={props.onKeyUp}
                                InputProps={{
                                    readOnly: false,
                                }}
                                form={form}
                            />
                        </div>
                    </div>
                    <br />
                    <div className="row search-form-container">
                        <div className="col form-col">
                            <SelectItem
                                dataUrl="api/sims/assessor/GetLookupList?listId=Province"
                                id="ProvinceID"
                                label="Province"
                                className="w-100"
                                form={form} />
                        </div>
                        <div className="col form-col">
                            <SelectItem
                                dataUrl="api/sims/assessor/GetLookupList?listId=AssessorRegistrationStatus"
                                id="AssessorRegistrationStatusID"
                                label="Assessor Registration Status"
                                className="w-100"
                                form={form} />
                        </div>
                    </div>
                </form>
            }
        </EntityForm>
    );
}
